import { AppProps } from 'next/app'
import Head from 'next/head'
import React from 'react'
import { ModalProvider } from 'react-modal-hook'
import { ToastProvider } from 'react-toast-notifications'
import { LiveChatLoaderProvider } from 'react-live-chat-loader'
import { init } from '../backend/sentry'
import { InitSplitbee } from '../components/InitSplitbee'
import { Layout } from '../components/Layout'
import '../styles/global.scss'
import '../styles/index.scss'
import '../styles/playground.css'
import '../styles/tailwind.css'
import '../styles/prism.css'
import { Provider } from 'urql'
import { client } from '../utils/urql-client'
import { MDXProvider } from '@mdx-js/react'
import { mdxComponents } from '../components/mdxComponents'

init()

const description = `Caching static assets is not enough. Start caching your GraphQL queries today.`
const image = 'https://graphcdn.io/social.png'

function App({ Component, pageProps, router }: AppProps): React.ReactNode {
  return (
    <ModalProvider>
      <ToastProvider>
        <MDXProvider components={mdxComponents}>
          <Provider value={client}>
            <Head>
              <title>GraphCDN - The GraphQL CDN</title>
              <link
                rel='icon'
                type='image/png'
                sizes='128x128'
                href='/favicon-128.png'
              />
              <link
                rel='icon'
                type='image/png'
                sizes='64x64'
                href='/favicon-64.png'
              />
              <link
                rel='icon'
                type='image/png'
                sizes='32x32'
                href='/favicon-32.png'
              />
              <link
                rel='icon'
                type='image/png'
                sizes='16x16'
                href='/favicon-16.png'
              />
              <link rel='apple-touch-icon' href='/apple-touch-icon.png' />
              <meta name='theme-color' content='#F8FAFC' />
              <meta name='title' content='GraphCDN - The GraphQL CDN' />
              <meta name='description' content={description} />
              <meta property='og:type' content='website' />
              <meta property='og:url' content='https://graphcdn.io/' />
              <meta property='og:title' content='GraphCDN - The GraphQL CDN' />
              <meta property='og:description' content={description} />
              <meta property='og:image' content={image} />
              {/* Twitter */}
              <meta property='twitter:card' content='summary_large_image' />
              <meta property='twitter:url' content='https://graphcdn.io/' />
              <meta
                property='twitter:title'
                content='GraphCDN - The GraphQL CDN'
              />
              <meta property='twitter:description' content={description} />
              <meta property='twitter:image' content={image} />
              {process.env.NODE_ENV === 'production' ? (
                <link
                  rel='stylesheet'
                  type='text/css'
                  href='https://cloud.typography.com/7127338/7575032/css/fonts.css'
                />
              ) : (
                <link
                  rel='stylesheet'
                  type='text/css'
                  href='https://cloud.typography.com/7127338/7259032/css/fonts.css'
                />
              )}
            </Head>
            <Layout router={router}>
              <LiveChatLoaderProvider
                providerKey={
                  process.env.NODE_ENV === 'production' && 'tf6tg08t'
                }
                provider='intercom'
                key={router.pathname}
                idlePeriod={50}
              >
                <Component {...pageProps} />
              </LiveChatLoaderProvider>
            </Layout>
            <InitSplitbee />
          </Provider>
        </MDXProvider>
      </ToastProvider>
    </ModalProvider>
  )
}
export default App
